import React from 'react';
import {useParams} from "react-router-dom";

import Config from "../Helpers/config";

function Logout() {
    const params = useParams();
    let message;
    let redirectUrl = `${process.env.REACT_APP_LOGIN_URL}/Account/Logout?PostLogoutRedirectUri=${process.env.REACT_APP_REDIRECT_URL}`;

    switch (params.reason) {
        case "403":
            message = (<div>
                You do not have the correct role to use this portal, please contact your administrator for access <br />
                Click <a href={redirectUrl}>here</a> to logout
            </div>)
            break;
        default:
            window.location.href=redirectUrl;
            message = (
                <div>
                    If you are not re-directed please click <a href={redirectUrl}>here</a> to logout
                </div>
            );
            break;

    }

    return message
}

export default Logout;
